import { NgModule }                        from '@angular/core';
import { GroupModule }                     from '@shared/components/group/group.module';
import { FormElementsGroupBlockComponent } from '@shared/form-elements/form-elements-group-block/form-elements-group-block.component';

@NgModule( {
	declarations: [
		FormElementsGroupBlockComponent
	],
	imports: [
		// Shared
		GroupModule
	],
	exports: [
		FormElementsGroupBlockComponent
	]
} )
export class FormElementsGroupBlockModule {}
